<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import HomePage from './views/HomePage.vue'
import Img360App from './img360/Img360App.vue'
import ImgTool2App from './imgtool2/ImgTool2App.vue'

const currentPath = ref(window.location.pathname)

function handleRouteChange() {
  currentPath.value = window.location.pathname
}

onMounted(() => {
  window.addEventListener('popstate', handleRouteChange)
})

onUnmounted(() => {
  window.removeEventListener('popstate', handleRouteChange)
})

const isImg360 = () => /^\/360img\/?$/.test(currentPath.value)
const isImgTool2 = () => /^\/imgtool2\/?$/.test(currentPath.value)
</script>

<template>
  <Img360App v-if="isImg360()" />
  <ImgTool2App v-else-if="isImgTool2()" />
  <HomePage v-else />
</template>
